import React, { useEffect } from 'react';
import { Card } from '@material-ui/core';
import { AccountCircle as AccountCircleIcon } from '@material-ui/icons';

import CardTitle from '../../../common/card/CardTitle';
import CardContent from '../../../common/card/CardContent';
import InlineForm from '../../../common/inline/InlineForm';
import InlineFormik from '../../../common/inline/InlineFormik';
import InlineSelect from '../../../common/inline/InlineSelect';
import InlineTextField from '../../../common/inline/InlineTextField';
import InlineNumberField from '../../../common/inline/InlineNumberField';
import {
  BaseSporCardProps,
  SupplierPurchaseOrder
} from '../../supplier/Supplier.interface';
import { useUpdateSpor } from '../../supplier/Supplier.hooks';
import { WorkflowEntity } from '../../workflow/Workflow.interface';
import { useTaskEntityFields } from '../../workflow/Workflow.hooks';

export enum Department {
  Engineering = 'Engineering',
  HumanResources = 'Human Resources',
  QualityAndCompliance = 'Quality & Compliance',
  Marketing = 'Marketing',
  Finance = 'Finance'
}

export const DepartmentOptions = Object.entries(Department).map(
  ([key, value]) => ({
    value: key,
    label: value
  })
);

const RequesterDetailsFormCard: React.FC<BaseSporCardProps> = (
  props: BaseSporCardProps
) => {
  const { spor, onChange, onUpdate, onError } = props;
  const { isFieldDisabled } = useTaskEntityFields<WorkflowEntity.Spor>(
    spor.task
  );
  const { updatedSpor, isUpdating, updateError, updateSpor } = useUpdateSpor(
    spor.id
  );

  useEffect(() => {
    if (updatedSpor) {
      onChange?.(updatedSpor);
      onUpdate?.();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedSpor]);

  useEffect(() => {
    if (updateError) {
      onError?.(updateError);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateError]);

  return (
    <Card>
      <CardTitle>
        <AccountCircleIcon />
        Section 1: Requester Details
      </CardTitle>
      <CardContent padding='large'>
        <InlineFormik
          error={updateError}
          isSubmitting={isUpdating}
          initialValues={{
            requesterName: spor.requesterName || '',
            requesterDepartment: spor.requesterDepartment || '',
            requesterPhoneNumber: spor.requesterPhoneNumber || ''
          }}
          onSubmit={(values: Partial<SupplierPurchaseOrder>) => {
            updateSpor(values);
            onChange?.(values);
          }}
        >
          <InlineForm>
            <InlineTextField
              name='requesterName'
              label='Requester Name'
              placeholder='Enter Requester Name'
              disabled={isFieldDisabled('requesterName')}
            />
            <InlineNumberField
              phoneNumber
              name='requesterPhoneNumber'
              label='Phone Number'
              placeholder='Enter Phone Number'
              disabled={isFieldDisabled('requesterPhoneNumber')}
            />
            <InlineSelect
              name='requesterDepartment'
              label='Department'
              placeholder='Enter Department'
              options={DepartmentOptions}
              disabled={isFieldDisabled('requesterDepartment')}
            />
          </InlineForm>
        </InlineFormik>
      </CardContent>
    </Card>
  );
};

export default RequesterDetailsFormCard;
